import React from 'react'
import { BodyText, Button, Row, Col } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'

const PrivacyOptionTile = ({
  name,
  badge,
  title,
  description,
  linkText,
  onSectionClick,
}) => (
  <Row className="privacyHub_option">
    <img className="privacyHub_optionBadge" src={badge} alt={name} />
    <Col className="privacyHub_optionContent">
      <BodyText strong className="privacyHub_optionText">
        <Message id={title} />
      </BodyText>
      <BodyText className="privacyHub_optionText">
        <Message id={description} />
      </BodyText>
      <BodyText>
        <Message
          id={linkText}
          link={(innerMessage) => (
            <Button
              tertiary
              onClick={onSectionClick}
              id={`${name}Link`}
              name={name}
              className="privacyHub_optionLink"
            >
              {innerMessage}
              <span className="tertiary-button--icon" />
            </Button>
          )}
        />
      </BodyText>
    </Col>
  </Row>
)

export default PrivacyOptionTile
